// extracted by mini-css-extract-plugin
export default {"page":"page-placeholder_page__bsYwT","card":"page-placeholder_card__-OiF5","subtitle":"page-placeholder_subtitle__YHCEz","placeholder":"page-placeholder_placeholder__2hUCJ"};